<template>
  <div class="fee-settings">
     

      <h1 class="text-left mx-4 mt-2">Fee Settings</h1>
      <h5 class="text-left mx-4">{{ activeFeeSession.title }}</h5>

      <v-row no-gutters>
        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'FeeSettingsCategory' }">
            <h2 class="text--secondary text-left font-weight-medium">Fee Category</h2>
          </v-card>
        </v-col>  
        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'FeeSettingsParticulars' }">
            <h2 class="text--secondary text-left font-weight-medium">Fee Particulars</h2>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'FeeSettingsSchedule' }">
            <h2 class="text--secondary text-left font-weight-medium">Fee Schedule</h2>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'FeeSettingsStructure' }">
            <h2 class="text--secondary text-left font-weight-medium">Fee Structure</h2>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'FeeReceiptSettings' }">
            <h2 class="text--secondary text-left font-weight-medium">Fee Receipt Settings</h2>
          </v-card>
        </v-col>
      </v-row>
     
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "FeeSettings",
  computed: {
    ...mapGetters(["activeFeeSession"])
  },
  data() {
    return {
      
    };
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>